<ion-row class="ion-margin ion-justify-content-center">
  <ion-label>
    <b>
      {{ field.label }}
    </b>
  </ion-label>
</ion-row>

<!-- <ion-row
  class="ion-justify-content-center ion-margin-vertical"
  [ngClass]="{'c-formgroup-invalid': (imageUploadFormControl && imageUploadFormControl.dirty && imageUploadFormControl.invalid)
                                  || (drawingFormControl && drawingFormControl.dirty && drawingFormControl.invalid)
                                  || (markersFormControl && markersFormControl.dirty && markersFormControl.invalid)
                                  || (formDynamiqueFormArray && formDynamiqueFormArray.dirty && formDynamiqueFormArray.invalid)
  }"
> -->
<ion-row class="ion-justify-content-center ion-margin-vertical">
  <app-c-elements-marqueurs *ngIf="marqueurs" [startingDatas]="marqueurs" 
  [resizedWindowTrigger$]="resizedWindowTrigger$" [cannotMoveMarkers]="true" 
  [canClickMarkers]="true" [marqueurSize]="marqueurSize" [outsideDatasUpdate$]="pingUpdateMarqueurs$" (markerClicked)="emitMarkerClicked($event)" [marqueursForms]="formDynamiqueFormArray">
    <div class="c-container">
      <ng-container *ngIf="imageUploadFormControl && !modeShow && !isReadonly()">
        <div style="position: absolute; top: 16px; right: 16px;">
          <ion-button (click)="onImageButtonClick()" size="small" shape="round">
            <ion-icon slot="icon-only" name="image-outline"></ion-icon>
          </ion-button>
        </div>
      </ng-container>
      <ng-container *ngIf="displayBackgroundUrl; else Bli">
        <img [src]="displayBackgroundUrl" alt="" class="c-image-plan" (click)="openModalDrawingMarkers()">
      </ng-container>
      <div class="c-drawing" [ngStyle]="{'background-image': drawingFormControl && drawingFormControl.value ? 'url(' + drawingFormControl.value + ')' : 'none' }"></div>
    </div>
  </app-c-elements-marqueurs>
</ion-row>

<!-- Si une image n'est pas fournie  -->
<ng-template #Bli>
  <div class="c-cadre" (click)="openModalDrawingMarkers()"></div>
</ng-template>

<ng-container *ngIf="field?.fields?.markers as fieldMarqueurs">
  <app-c-sketch-legende [fieldMarqueurs]="fieldMarqueurs" [sourceMarqueurs]="markersFormControl?.value" (modifiedValue)="editMarqueurInfo($event)" [modeShow]="modeShow"></app-c-sketch-legende>
</ng-container>

<ng-container *ngIf="formDynamiqueFormArray && formDynamiqueFormArray.controls.length > 0 && field.fields.prototypeOnAddMarker">
  <app-c-forms-dynamiques
    style="overflow-x: scroll; width: 100%; display: block;"
    [modeShow]="modeShow"
    [etatId]="etatId"
    [formDynamiqueFormArray]="formDynamiqueFormArray"
    [formSketchFormDynamique]="field.fields.prototypeOnAddMarker"
    [blocName]="blocName"
    [display]="display"
    [context]="contextFromParentPage"
    [observeSourcesArr]="observeSourcesArrFromParent"
    [step]="step"
    [bloc]="bloc"
    [displayType]="'markerRow-fieldColum'"
    [fieldMarqueurs]="field?.fields?.markers"
    [sourceMarqueurs]="markersFormControl?.value"
    (modifiedDescription)="editMarqueurInfo($event)"
  ></app-c-forms-dynamiques>
</ng-container>

<!-- 
<ion-row class="ion-justify-content-center">
  ------------
</ion-row>

<ng-container *ngIf="formDynamiqueFormArray && field.fields.prototypeOnAddMarker">
  <app-c-forms-dynamiques
    [modeShow]="modeShow"
    [formDynamiqueFormArray]="formDynamiqueFormArray"
    [formSketchFormDynamique]="field.fields.prototypeOnAddMarker"
    [blocName]="blocName"
    [display]="display"
    [context]="contextFromParentPage"
    [observeSourcesArr]="observeSourcesArrFromParent"
    [step]="step"
    [bloc]="bloc"
    [displayType]="'markerColumn-fieldRow'"
  ></app-c-forms-dynamiques>
</ng-container> -->

<ng-container *ngIf="!isReadonly()
                  && cFormGroup.dirty
                  && cFormGroup.invalid
                  && (((markersFormControl && markersFormControl.dirty && markersFormControl.invalid)
                    || (imageUploadFormControl && imageUploadFormControl.dirty && imageUploadFormControl.invalid)
                    || (drawingFormControl && drawingFormControl.dirty && drawingFormControl.invalid)
                    || (imageUploadFormControl && imageUploadFormControl.dirty && imageUploadFormControl.invalid))
                   || (formDynamiqueFormArray && formDynamiqueFormArray.dirty && formDynamiqueFormArray.invalid))">
  <ion-item>
    <ion-text color="danger">
      <p style="font-size: 15px">
        Non conforme:
      </p>
      <ul style="font-size: 15px">
        <li *ngIf="markersFormControl && markersFormControl.dirty && markersFormControl.invalid">
          Marqueurs invalides<ng-container *ngIf="markersFormControl?.errors?.['err'].text && markersFormControl?.errors?.['err'].text">: ({{ markersFormControl?.errors?.['err'].text }})</ng-container>
        </li>
        <li *ngIf="imageUploadFormControl && imageUploadFormControl.dirty && imageUploadFormControl.invalid">
          Image à fournir invalide: Information obligatoire
        </li>
        <li *ngIf="drawingFormControl && drawingFormControl.dirty && drawingFormControl.invalid">
          Dessin invalide: Information obligatoire
        </li>
        <li *ngIf="formDynamiqueFormArray && formDynamiqueFormArray.dirty && formDynamiqueFormArray.invalid">
          Sous-formulaires liés aux marqueurs incorrectement remplis
        </li>
      </ul>
    </ion-text>
  </ion-item>
</ng-container>

<div class="c-separation">
  <div class="c-separation-inner">
  </div>
</div>
